import React from 'react';

export const FacebookSDKContext = React.createContext();
